import { Icon, Button } from 'ht-styleguide';
import styles from './addskunotice.module.scss';

/* Types */
type SkuNoticeProps = {
  visible: boolean;
  handleClick: BaseAnyFunction;
};

const SkuNotice = ({ handleClick, visible }: SkuNoticeProps) => {
  const iconName = visible ? 'ht-arrow-up' : 'ht-arrow-down';
  return (
    <Button small className={styles.skuButton} onClick={handleClick}>
      <p className="p1 text-weight-medium n000">Important Service Tips</p>
      <Icon name={iconName} className={styles.arrow} />
    </Button>
  );
};

export default SkuNotice;
